import { useIntl } from 'react-intl';
import type TrailRouteType from '@alltrails/trails/types/TrailRouteType';
import getTrailRouteTypeLabel from '@alltrails/trails/utils/getTrailRouteTypeLabel';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useChipsFilterConfig from './useChipsFilterConfig';

const routeTypes: TrailRouteType[] = ['O', 'L', 'P'];

const useRouteTypeChipsConfig = (exploreServiceFilters: ExploreServiceFilters, onFiltersChange: (updatedFilters: ExploreServiceFilters) => void) => {
  const intl = useIntl();

  return useChipsFilterConfig({
    exploreServiceFilterKey: 'routeType',
    exploreServiceFilters,
    getValueLabel: routeType => getTrailRouteTypeLabel(intl, routeType),
    label: intl.formatMessage({ defaultMessage: 'Route type' }),
    onFiltersChange,
    values: routeTypes
  });
};

export default useRouteTypeChipsConfig;
